import { EBikeRangeCalculator } from "../../../../src/components/BikeRangeCalculator";
import { RangeRecommendations } from "../../../../src/components/RangeRecommendations";
import * as React from 'react';
export default {
  EBikeRangeCalculator,
  RangeRecommendations,
  React
};